












































import { defineComponent } from '@nuxtjs/composition-api';
import { IBlokSingleImage } from '~/components/storyblok/SingleImage.vue';
import type { PropType } from '@nuxtjs/composition-api';
import { SfButton } from '~/components/StorefrontUi';
import { addBasePath } from '~/helpers/addBasePath';
import { IconArrowSmallRight } from '../General/icons';

interface Blok {
  _uid: string;
  title: string;
  description?: string;
  price_text?: string;
  tag?: string;
  image?: IBlokSingleImage[];
  color: {
    color: string;
  };
  linkLabel?: string;
  link?: {
    cached_url: string;
    fieldtype: string;
    linktype: string;
  };

}

export default defineComponent({
  name: 'InfoSection',
  components: {
    SfButton,
    IconArrowSmallRight,
  },
  props: {
    blok: {
      type: Object as PropType<Blok>,
      required: true,
    },
  },
  setup({ blok }: { blok: Blok }) {
    const color = blok.color?.color || '#01652D';
    const bgGradientStyle = {
      background: `linear-gradient(90deg, ${color} 0%, ${color} 55%, ${color}00 93%)`,
    };

    return {
      color,
      bgGradientStyle,
      addBasePath,
    };
  },
});
